module.exports = __webpack_public_path__ + "img/erCode.cd8c8a1e.png";